<template>
    <div class="marketingCenterIndex spackage padding-20 bgc box-shadow">

        <section class="mgtlist" v-for="(list,index) in mgtList" :key="index">
            <h1 class="tag">{{list.name}}</h1>

            <div class="card" v-for="(item, i) in list.data" :key="i" @click="goto(item.href)">
                <!--<a :href="item.href">-->
                    <div :class="{'card-img':true,'type2':item.type==2,'type3': item.type==3 }">
                        <img :src="item.img" alt="icon">
                    </div>
                    <div class="card-msg">
                        <p class="title">{{item.title}}</p>
                        <p class="des">{{item.des}}</p>
                    </div>
                <!--</a>-->
            </div>

        </section>


    </div>
</template>

<script>
    export default {
        name: "MarketingCenterIndex",
        data(){
          return {
              mgtList:[
                  {
                      id:1,
                      name:"消息推送",
                      data: [
                          {title:"短信",href:"/marketingCenter/MarketingCenter",img:require('@/common/images/toolmgt/icon_14.png'),des:"新老客户群发消息",type:1},
                          {title:"微信公众号",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_5.png'),des:"关注用户消息通知",type:1},
                          {title:"小程序",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_6.png'),des:"关联用户及时消息通知",type:1}
                      ]
                  },
                  {
                      type:2,
                      name:"营销玩法",
                      data:[
                        {title:"优惠码",href:"/marketingCenter/coupon/couponList",img:require('@/common/images/toolmgt/icon_15.png'),des:"赠送免费体验权益",type:2},
                        {title:"优惠券",href:"/marketingCenter/discountCoupon",img:require('@/common/images/toolmgt/icon_16.png'),des:"赠送免费体验权益",type:2},
                        {title:"拼团",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_8.png'),des:"多人拼单享受优惠",type:2},
                        {title:"好友助力",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_9.png'),des:"好友点赞免费听课",type:2},
                        {title:"限时折扣",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_11.png'),des:"限时限量打折减价",type:2},
                        {title:"商品分销",href:"/marketingCenter/commodityDistribution/commodityDistributionSetting",img:require('@/common/images/toolmgt/icon_13.png'),des:"客户帮你卖，员工帮你卖",type:2},
                        {title:"商品推荐",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_12.png'),des:"为你推荐最好商品",type:2},
                        {title:"裂变海报",href:"/marketingCenter/MarketingCenterIndex",img:require('@/common/images/toolmgt/icon_10.png'),des:"刷屏裂变快速引流",type:2}
                      ]
                  }
              ]
          }
        },
        methods: {
            goto(href){
                this.$router.push(href)
            }
        }
    }
</script>

<style lang="scss">
    .marketingCenterIndex {
        min-height: 800px;
        .mgtlist {
            margin-bottom: 60px;
        }
        .tag {
            font-size:16px;
            color:#303133;
            padding-left: 8px;
            border-left: solid 2px #409EFF;
        }
        .card {
            display: inline-block;
            margin-top: 30px;
            margin-right: 30px;
            padding: 15px;
            width: 300px;
            height: 80px;
            box-sizing: border-box;
            background: #F5F7FA;
            cursor: pointer;

            .card-img {
                display: inline-block;
                width: 50px;
                height: 50px;
                background: #67C23A;
                img {
                    display: block;
                    margin: auto;
                    padding-top: 7px;
                    width: 36px;
                    height: 36px;
                }
            }
            .card-img.type2 {
                background:#F56C6C;
            }

            .card-msg {
                float: right;
                display: inline-block;
                width: 210px;

                .title {
                    margin-top: 5px;
                    font-size:16px;
                    color: #303133;
                }
                .des {
                    margin-top: 12px;
                    font-size: 14px;
                    color: #909399;
                }
            }

        }
        .card:hover {
            box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -webkit-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -ms-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -o-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -moz-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
        }
    }

</style>
